<template>
  <div class="py-3 h-100">
    <div class="d-flex justify-content-between align-items-center">
      <p class="my-4">Subworks</p>
      <div>
        <button class="btn btn-primary" @click="addSubwork()">
          <i class="fa-solid fa-plus me-2" />
          Add Subwork
        </button>
      </div>
    </div>

    <div
      class="text-center bg-secondary fst-italic p-3 rounded"
      v-if="!subworks.length"
    >
      No subwork added
    </div>

    <div class="row row-cols-1 row-cols-md-2 g-3">
      <div class="col" v-for="work in subworks" :key="work.id">
        <button
          class="btn btn-secondary w-100 text-start px-4 py-3 d-flex justify-content-between align-items-start"
          @click="addSubwork(work)"
        >
          <div class="flex-fill">
            <p class="fw-bold lead mb-2">{{ work.name }}</p>
            <p class="mb-1">
              <i class="fas fa-clock me-2" style="width: 16px" />
              {{ Helper.formatDate(work.datetime, true) || "Not set" }}
            </p>
            <p>
              <i class="fas fa-location-pin me-2" style="width: 16px" />
              {{ Helper.formatCoordinate([work.lat, work.lng]) }}
            </p>
          </div>
          <div class="flex-nowrap d-flex lh-sm">
            <div class="bg-dark rounded square fw-bold me-2">
              <span class="fs-1">{{ imageCount(work) }}</span>
              <span>IMAGES</span>
            </div>
            <div class="bg-dark rounded square fw-bold">
              <span class="fs-1">{{ videoCount(work) }}</span>
              <span>VIDEOS</span>
            </div>
          </div>
        </button>
      </div>
    </div>

    <edit-subwork-modal
      :show="showEditSubworkModal"
      :subwork="currentSubwork"
      :pavement-id="pavementId"
      :pavement-data="pavementData"
      @open-media-preview="$emit('open-media-preview', $event)"
      @close="closeEditSubworkModal"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import EditSubworkModal from "@/components/EditSubworkModal";

export default {
  props: ["componentId", "status", "pavementId", "pavementData"],
  components: { EditSubworkModal },
  data() {
    return {
      subworks: [],
      showEditSubworkModal: false,
      currentSubwork: null,
    };
  },
  computed: {
    imageCount() {
      return (work) => {
        return (
          (work.img_before?.length || 0) +
          (work.img_during?.length || 0) +
          (work.img_after?.length || 0)
        );
      };
    },
    videoCount() {
      return (work) => {
        return (work.video_before ? 1 : 0) + (work.video_after ? 1 : 0);
      };
    },
  },
  methods: {
    closeEditSubworkModal(e) {
      this.showEditSubworkModal = false;

      this.currentSubwork = null;

      if (e) {
        this.getSubworks();
      }
    },
    async addSubwork(work) {
      if (work) {
        this.currentSubwork = work;
      }

      this.showEditSubworkModal = true;
    },
    async uploadFileInput(fileName) {
      return new Promise(async (resolve, reject) => {
        const data = {
          pavement_case: this.pavementId,
          name: fileName,
        };

        const formData = new FormData();

        formData.append("data", JSON.stringify(data));

        formData.append("files.file", this.fileInput, this.fileInput.name);

        const [call, error] = await this.Helper.handlePromise(
          this.API.postForm("pavement-pqps", formData)
        );

        if (error) {
          return reject(error);
        } else {
          return resolve("OK");
        }
      });
    },
    triggerAlert(icon, text, callback, callbackData) {
      Swal.fire({
        icon: icon,
        title: `<h5>${text}</h5>`,
      }).then(() => {
        if (callback) {
          this.$emit(callback, callbackData);
        }
      });
    },
    async getSubworks() {
      if (this.pavementId) {
        this.Helper.toggleLoadingSpinner(true);

        const [call, error] = await this.Helper.handlePromise(
          this.API.get(`pavement-works?pavement_case=${this.pavementId}`)
        );

        if (error) {
          this.triggerAlert("error", "Error getting subwork data");
        } else {
          this.subworks = call.data;
        }

        this.Helper.toggleLoadingSpinner(false);
      }
    },
  },
  async mounted() {
    await this.getSubworks();
  },
};
</script>

<style lang="scss" scoped>
.square {
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>